import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withStyles } from "@material-ui/core/styles";
import Rating from "@material-ui/lab/Rating";
import React, { PropsWithChildren, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import lang from "../functions/lang";
import { ScrollBarConfig } from "../functions/ScrollBarConfig";
import { useAirbnb } from "../Hooks/useAirbnb";
import { useGoogle } from "../Hooks/useGoogle";
import { Store } from "../interfaces/IStore";
import { AppContext } from "./AppContext";
import AirbnbResults from "./Icons/AirbnbResults";
import DirectionsIcon from "./Icons/DirectionsIcon";
import HotelResults from "./Icons/HotelResults";
import InfoIcon from "./Icons/InfoIcon";
import PhoneIcon from "./Icons/PhoneIcon";
import StoreResults from "./Icons/StoreResults";
import { Loader } from "./Loader";

const StoreName = styled.h4`
  margin: 0;
  color: #522398;
  text-transform: uppercase;
  font-size: 18px;
  padding-bottom: 12px;
`;

const StoreAddress = styled.p`
  font-size: 18px;
`;
const MetaWrapper = styled.div`
  display: flex;
  flex-flow: row;
  align-items: end;
  padding-bottom: 5px;
`;

const Table = styled.table`
  width: 100%;
  margin-top: 1rem;
`;

const DirectionsContainer = styled.div``;

const PhoneContainer = styled.div``;

const StyledRating = withStyles({
  iconFilled: {
    color: "#ffd200!important",
  },
  iconEmpty: {
    color: "#bdbdbd!important",
  },
})(Rating);

const A = styled.a`
  color: #522398;
  font-size: 18px;
  text-decoration: none;
  padding-left: 11px;
`;

const AvailableProductsContainer = styled.div``;

const AvailableProductsHeader = styled.h5`
  margin: 0;
  padding-top: 1.3rem;
  font-size: 18px;
  color: #522398;
`;

const AvailableProductsList = styled.ul`
  margin: 10px;
  padding: 0;
  padding-left: 1.2rem;
`;

const StoreLinkContainers = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  :nth-child(2) {
    margin-top: 3px;
  }
`;

const AvailableProductListItems = styled.li`
  padding: 0.1rem;
  font-size: 18px;
  text-transform: capitalize;
`;

const StoreHoursContainer = styled.div``;

const StoreHoursHeader = styled.h5`
  margin: 0;
  padding-top: 1.3rem;
  font-size: 18px;
  color: #522398;
`;

const IconImage = styled.img`
  width: 1.2rem;
  height: 1.2rem;
`;

const StarRatingsWrapper = styled.div`
  padding-left: 9px;
  margin-bottom: -3px;
`;

const MapWrapper = styled.div`
  padding-left: 2px;
  padding-bottom: 2px;
  display: flex;
`;
const PhoneWrapper = styled.div`
  padding-left: 4px;
  padding-bottom: 2px;
  display: flex;
`;
const InfoWrapper = styled.div`
  padding-left: 1px;
  margin-right: -1px;
  padding-bottom: 2px;
  display: flex;
`;

interface IStoreContent {
  currentStore: Store | undefined;
}

declare global {
  interface Window {
    targetStore?: string;
    competitor?: {
      locationName?: string;
      coords?: {
        lat?: number | string;
        lng: number | string;
      };
      avgRatings: number;
      placeId: string | number;
      business_type: string;
    }[];
    data?: {
      [key: string]: any;
    };
  }
}

export const StoreContent = ({ currentStore }: PropsWithChildren<IStoreContent>) => {
  const { setSearchResultCoords } = useContext(AppContext);
  const airbnbData = useAirbnb(currentStore);
  const googleData = useGoogle(currentStore);

  console.log({ currentStore, airbnbData, googleData });
  let StoreContentWrapper = styled.div`
    position: relative;
    top: 0;
    bottom: 0;
    flex-grow: 1;
    flex-shrink: 1;
    overflow: auto;
    display: flex;
  `;

  const [size, setSize] = useState(window.innerWidth <= 770 ? "mobile" : "desktop");
  let MoreInfoContainer = styled.div`
    position: ${size == "mobile" ? "unset" : "absolute"};
    margin-top: 1rem;
    bottom: 24%;
  `;
  size == "mobile"
    ? (StoreContentWrapper = styled.div`
        height: 12rem;
        overflow: auto;
        padding-bottom: 3.4rem;
        ${ScrollBarConfig}
      `)
    : (StoreContentWrapper = styled.div`
        height: ${window?.singleStore ? "auto" : "calc(100vh - 51px - 0.6rem - 135px - 8rem);"}
        overflow: auto;
        ${ScrollBarConfig}
      `);

  return (
    <>
      <StoreContentWrapper>
        <StoreName
          onClick={() =>
            currentStore &&
            setSearchResultCoords({
              lat: currentStore?.latitude,
              lng: currentStore?.longitude,
            })
          }>
          {currentStore?.name_en}
        </StoreName>
        {(currentStore?.google_id && !googleData?.loading) || (currentStore?.airbnb_id && !airbnbData.loading) ? (
          <>
            <MetaWrapper>
              {currentStore?.business_type == "airbnb" ? <AirbnbResults /> : null}

              {currentStore?.business_type == "hotel" ? <HotelResults /> : null}

              {currentStore?.business_type == "store" ? <StoreResults /> : null}
              <style dangerouslySetInnerHTML={{ __html: `.fa-star { color: unset; }` }} />
              <StarRatingsWrapper>
                <StyledRating
                  name="customized-color"
                  defaultValue={0}
                  value={
                    (currentStore?.airbnb_id && (airbnbData?.starRating || 0)) ||
                    (currentStore?.google_id && (googleData?.starRating || 0)) ||
                    0
                  }
                  precision={0.5}
                  color={"red"}
                  icon={<FontAwesomeIcon icon={faStar} />}
                  size={"small"}
                  readOnly
                />
              </StarRatingsWrapper>
            </MetaWrapper>
            {/* Store Address  */}
            {currentStore.business_type !== "airbnb" && currentStore?.google_id && googleData?.storeAddress && (
              <StoreAddress>{googleData?.storeAddress}</StoreAddress>
            )}
            {currentStore?.airbnb_id && currentStore.business_type === "airbnb" && airbnbData?.storeAddress && (
              <StoreAddress>{airbnbData?.storeAddress}</StoreAddress>
            )}
            <div>
              {currentStore.business_type !== "airbnb" && googleData?.phoneNumber ? (
                <StoreLinkContainers>
                  <PhoneWrapper>
                    <PhoneIcon />
                  </PhoneWrapper>
                  <A href={`tel:+1${googleData?.phoneNumber.replace(/[()-\.\s]/g, "")}`}>{googleData?.phoneNumber}</A>
                </StoreLinkContainers>
              ) : currentStore.business_type !== "airbnb" && airbnbData?.phoneNumber ? (
                <StoreLinkContainers>
                  <PhoneWrapper>
                    <PhoneIcon />
                  </PhoneWrapper>
                  <A href={`tel:+1${airbnbData?.phoneNumber.replace(/[()-\.\s]/g, "")}`}>{airbnbData?.phoneNumber}</A>
                </StoreLinkContainers>
              ) : null}
              {currentStore?.business_type !== "airbnb" &&
              googleData?.storeAddress &&
              googleData?.googleDirectionsAPI ? (
                <StoreLinkContainers>
                  <>
                    <MapWrapper>
                      <DirectionsIcon />
                    </MapWrapper>
                    {/* <span> - </span> */}
                    <A href={googleData?.googleDirectionsAPI} target="blank">
                      {lang("storeCard.directions", window.data?.language || "en")}
                    </A>
                  </>
                </StoreLinkContainers>
              ) : null}
              {currentStore?.business_type === "airbnb" && currentStore?.airbnb_id && (
                <StoreLinkContainers>
                  <InfoWrapper>
                    <DirectionsIcon />
                  </InfoWrapper>
                  {/* <span> - </span> */}
                  <A
                    href={`https://${window.data?.language === "fr" ? "fr" : "www"}.airbnb.ca/rooms/${
                      currentStore?.airbnb_id
                    }`}
                    target={"blank"}>
                    {lang("storeCard.view_airbnb", window.data?.language || "en")}
                  </A>
                </StoreLinkContainers>
              )}
              {(currentStore?.url_fr || currentStore?.url || googleData?.storeUrl) && (
                <StoreLinkContainers>
                  <InfoWrapper>
                    <InfoIcon />
                  </InfoWrapper>
                  {/* <span> - </span> */}
                  <A
                    href={
                      window.data?.language === "fr" && currentStore?.url_fr
                        ? currentStore.url_fr
                        : currentStore?.url
                        ? currentStore.url
                        : googleData?.storeUrl
                    }
                    target={"blank"}>
                    {lang("storeCard.more_info", window.data?.language || "en")}
                  </A>
                </StoreLinkContainers>
              )}
            </div>
            {/* Available products container */}
            {currentStore?.products.length > 0 ? (
              <AvailableProductsContainer>
                {/* Available products header */}
                <AvailableProductsHeader>
                  {lang("storeCard.available_products", window.data?.language || "en")}
                </AvailableProductsHeader>
                <div>
                  <AvailableProductsList>
                    {currentStore?.products.map((product) => {
                      return (
                        <AvailableProductListItems>
                          {lang(`filters.products.${product}`, window.data?.language || "en")}
                        </AvailableProductListItems>
                      );
                    })}
                  </AvailableProductsList>
                </div>
              </AvailableProductsContainer>
            ) : null}

            {googleData?.storeHours &&
            Object.entries(googleData?.storeHours).length > 0 &&
            currentStore?.business_type !== "airbnb" ? (
              <StoreHoursContainer>
                {googleData?.storeHours ? (
                  <>
                    <StoreHoursHeader>
                      {lang("storeCard.opening_hours.header", window.data?.language || "en")}
                    </StoreHoursHeader>
                    <Table>
                      <tbody>{googleData?.storeHours.map((h: any) => h)}</tbody>
                    </Table>
                  </>
                ) : null}
              </StoreHoursContainer>
            ) : null}
          </>
        ) : (
          <Loader />
        )}
      </StoreContentWrapper>
    </>
  );
};
